const ApiService = Shopware.Classes.ApiService;

/**
 * @class
 * @extends ApiService
 */
class TrustpilotRecoverInvitationService extends ApiService {
    /**
     * @constructor
     * @param {AxiosInstance} httpClient
     * @param loginService
     * @param context
     * @param apiEndpoint
     */
    constructor(httpClient, loginService, context, apiEndpoint = 'ecocode/trustpilot') {
        super(httpClient, loginService, apiEndpoint);
        this.name = 'ecocodeTrustpilotRecoverInvitationService';
        this.context = context;
    }

    recoverInvitations(data) {
        const headers = this.getBasicHeaders();

        return this.httpClient
            .post(
                `/_action/${this.getApiBasePath()}/invitations/recover`,
                data,
                {
                    headers: headers,
                    baseURL: this.context.apiPath
                }
            )
            .then((response) => {
                return ApiService.handleResponse(response);
            });
    }

    recoverInvitationsCount(data) {
        const headers = this.getBasicHeaders();

        return this.httpClient
            .post(
                `/_info/${this.getApiBasePath()}/invitations/recover_count`,
                data,
                {
                    headers: headers,
                    baseURL: this.context.apiPath
                }
            )
            .then((response) => {
                return ApiService.handleResponse(response);
            });
    }
}

export default TrustpilotRecoverInvitationService;
